import { Card, List, Space } from 'antd';
import { type RoleSpecsFragment } from '../../../api/fragments/RoleSpecs';
import RolePermissionEmptyList from './RolePermissionEmptyList';
import RolePermissionListActions from './RolePermissionListActions';
import RoleTags from './RoleTags';

export type RolePermissionListProps = { role: RoleSpecsFragment };

const RolePermissionList = ({ role }: RolePermissionListProps) => {
    if (role.permissions.length === 0) {
        return <RolePermissionEmptyList role={role} />;
    }

    return (
        <Card>
            <List size="small">
                {role.permissions.map(permission => (
                    <List.Item
                        key={permission.id}
                        extra={<RolePermissionListActions permission={permission} role={role} />}
                    >
                        <List.Item.Meta
                            description={
                                <Space direction="vertical" style={{ width: '100%' }}>
                                    <span>{permission.description}</span>
                                    <RoleTags tags={permission.tags} />
                                </Space>
                            }
                            title={permission.displayName}
                        />
                    </List.Item>
                ))}
            </List>
        </Card>
    );
};

export default RolePermissionList;
